

import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
created(){
this.getPhone();
},

data () {
return {
model:{m_token:this.$route.query.token},
phone:"",
}
},
methods: {
goBack(){
this.$router.push({
path : '/user/editInfo',
query : {}
})
},
getPhone(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getMobile',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.phone=res.body.user.mobile;
}
},function(res){
console.log(res.status);
});
},
changePw(){
if(this.model.newWord == null || this.model.newWord==undefined){
alert("新密码不能为空")
return ;
}
if(this.model.newWord2 == null || this.model.newWord2==undefined){
alert("确认密码不能为空")
return ;
}
if(this.model.newWord != this.model.newWord2){
alert("两次新密码不匹配")
return ;
}

let oldPassword = this.$getRsaCode(this.model.oldPW);

let newPassword = this.$getRsaCode(this.model.newWord);;

this.$http.post(this.global.httpUrl + '/rest/v1/m/user/changePassword',{oldPW:oldPassword,newWord:newPassword},{emulateJSON:true}).then(function(res){
if(res.body.success)
{
alert("修改成功");
window.location="/auth/login";
} else{
alert(res.body.message);


}
},function(res){
console.log(res.status);
});

},

}
}



// WEBPACK FOOTER //
// ./src/views/user/changePassword.vue